import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Health = lazy(() => import('../components/Health'));
const PreloadShell = lazy(() => import('../components/preload-shell'));
const UserSubmission = lazy(() => import('../components/UserSubmission/UserSubmission'));
const FinishSubmission = lazy(() => import('../components/UserSubmission/FinishSubmission'));
const NonRetailerVerification = lazy(
	() => import('../components/non-retailer-verification/NonRetailerVerification')
);
const Referral = lazy(() => import('../AppReferral/Referral'));
const MandiBhavReferral = lazy(() => import('../AppReferral/MandiBhavReferral'));
const PointsEarning = lazy(() => import('../components/incentive/PointsEarning'));
const EditName = lazy(() => import('../name-shop-change/EditName'));
const PostDeliveryFlow = lazy(() => import('../components/post-delivery-flow'));
const OrderAction = lazy(() => import('../components/order-action/OrderAction'));
const CancelOrderPage = lazy(() => import('../components/order-action/CancelOrderPage'));
const GhadiCashbackPlan = lazy(() => import('../components/ghadi-new-scheme'));
const VoiceAddress = lazy(() => import('../components/voice-address'));
const PriceCompare = lazy(() => import('../components/price-compare'));
const CustomHtmlRedirect = lazy(() => import('../components/custom-html-redirect'));
const SchemeChampion = lazy(() => import('../components/scheme-champion'));
const VoiceRecorderTest = lazy(() => import('../components/voice-recorder-test'));
const RewardTdsPan = lazy(() => import('../components/reward-tds-pan'));
const LocalBrandUpload = lazy(() => import('../components/local-brand-upload'));
const LiveOrderVideo = lazy(() => import('../components/live-order-video'));

const miscRoutes = (
	<>
		<Route path="/health" element={<Health />} />
		<Route path="/preload-shell" element={<PreloadShell />} />
		<Route path="/usersubmission/finishsubmission" element={<FinishSubmission />} />
		<Route path="/usersubmission" element={<UserSubmission />} />
		<Route path="/nonretailer/verification" element={<NonRetailerVerification />} />
		<Route path="/incentives/ways-to-earn-points" element={<PointsEarning />} />
		<Route path="/referral" element={<Referral />} />
		<Route path="/mandi-bhav-referral" element={<MandiBhavReferral />} />
		<Route path="/edit-name" element={<EditName />} />
		<Route path="/post-delivery-flow/:orderId" element={<PostDeliveryFlow />} />
		<Route path="/order-action" element={<OrderAction />} />
		<Route path="/order-action/cancel" element={<CancelOrderPage />} />
		<Route path="/ghadi-cashback-plan" element={<GhadiCashbackPlan />} />
		<Route path="/voice-address" element={<VoiceAddress />} />
		<Route path="/price-compare" element={<PriceCompare />} />
		<Route path="/custom-html" element={<CustomHtmlRedirect />} />
		<Route path="/scheme-champion" element={<SchemeChampion />} />
		<Route path="/voice-recorder-test" element={<VoiceRecorderTest />} />
		<Route path="/reward-tds/pan" element={<RewardTdsPan />} />
		<Route path="/local-brand-upload" element={<LocalBrandUpload />} />
		<Route path="/live-order-video" element={<LiveOrderVideo />} />
	</>
);

export default miscRoutes;
